import React from 'react'
import './App.css'
import MainRouters from './MainRouters'
import { Provider } from 'react-redux'
import { store } from './redux'

function App() {
  return (
    <Provider store={store}>
      <MainRouters />
    </Provider>
  )
}

export default App
